<script setup>
import { defineProps, defineEmits } from "vue";
import { getFilePreview } from "@/utils/files";
import { truncateString } from "@/utils/utils";

const props = defineProps({
  attachments: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(["delete-file"]);

// Emit delete event to parent
const emitDelete = (index) => {
  emit("delete-file", index);
};
</script>

<template>
  <div class="attachment-carousel">
    <div
      v-for="(file, index) in attachments"
      :key="index"
      class="attachment-card"
    >
      <!-- Load image -->
      <img
        v-if="file.type.startsWith('image/')"
        :src="getFilePreview(file)"
        class="preview-img"
      />

      <!-- Fallback image -->
      <div v-else class="file-info">📄 <span>{{ truncateString(file.name, 20) }}</span></div>

      <button class="delete-btn" @click="emitDelete(index)">
        <Icon icon="close" style="stroke: black" />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.attachment-carousel {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding: 10px;
}

.attachment-card {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0.25em;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.preview-img {
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
}

.file-info {
  font-size: 14px;
  text-align: center;
  padding: 5px;

  > span {
    word-break: break-word;
  }
}

/* .delete-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
} */

.delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease;
}

.delete-btn:hover {
  background: #f0f0f0;
}
</style>
